import { baseDatabaseSchema, type PK } from '@domain/schemas/database.schema';
import { z } from 'zod';

export const TeamSchema = z
  .object({
    name: z.string(),
  })
  .strict();

export const DbTeamSchema = TeamSchema.merge(baseDatabaseSchema).extend({
  id: z.number(),
  status: z.enum(['Active', 'Disabled']),
});
export type DbTeam = z.infer<typeof DbTeamSchema> & PK;
export type Team = Pick<DbTeam, 'id' | 'name'> & Partial<Pick<DbTeam, 'status'>>;
